import { useCallback } from 'react';
import { isSiteOptedOut } from '@atlassian/cross-join-nudges';
import { useCloudId } from '@atlassian/jira-tenant-context-controller/src/components/cloud-id/index.tsx';
import { fg } from '@atlassian/jira-feature-gating';

export const useIsSiteOptedOut = () => {
	const cloudId = useCloudId();

	return useCallback(async () => {
		if (!fg('tap-opt-out-aioli')) {
			return false;
		}

		return isSiteOptedOut(cloudId);
	}, [cloudId]);
};
